import request from "@/utils/request";

export default function agentDisableAutoWithdrawMoney() {
    return request({
        url: `/user/agent/agentDisableAutoWithdrawMoney`,
        method: 'post',
    })
}
